export const AUTH_ACTION = {
  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT',
  ACTIVE_ACCOUNT: 'ACTIVE_ACCOUNT',
  SHOW_OTP_REGISTERED_PAGE: 'SHOWOTPREGISTEREDPAGE'
}

export const USER = {
  ACTIVE_STATE: 'E'
}

export const ACCOUNT_TYPE = {
  CASH: 'C',
  MARGIN: 'M',
  CUSTODIAN: 'X'
}

export const authErrType = {
  EXPIRED_SESSION: 'EXPIRED_SESSION'
}

export const APP_LOGIN_CHANNEL = 'INT' //'QL_PC'